const createValidLink = (url) => {
    if (!url) {
        return;
    }
    return url.endsWith('/') ? url : `${url}/`
}

export default createValidLink;